/** Periodicidades aceitas pela EFI / Pix Automático (BC). */
export const PERIODICIDADES_PIX = [
  'SEMANAL',
  'MENSAL',
  'TRIMESTRAL',
  'SEMESTRAL',
  'ANUAL',
] as const

export type PeriodicidadePix = (typeof PERIODICIDADES_PIX)[number]

export const PERIODICIDADE_LABELS: Record<PeriodicidadePix, string> = {
  SEMANAL: 'Semanal',
  MENSAL: 'Mensal',
  TRIMESTRAL: 'Trimestral',
  SEMESTRAL: 'Semestral',
  ANUAL: 'Anual',
}

export const PERIODICIDADE_SUFIXO_PRECO: Record<PeriodicidadePix, string> = {
  SEMANAL: '/semana',
  MENSAL: '/mês',
  TRIMESTRAL: '/trimestre',
  SEMESTRAL: '/semestre',
  ANUAL: '/ano',
}

export const PERIODICIDADE_ADJETIVO_PLURAL: Record<PeriodicidadePix, string> = {
  SEMANAL: 'semanais',
  MENSAL: 'mensais',
  TRIMESTRAL: 'trimestrais',
  SEMESTRAL: 'semestrais',
  ANUAL: 'anuais',
}

export function normalizarPeriodicidade(
  value?: string | null
): PeriodicidadePix {
  const upper = String(value || 'MENSAL').trim().toUpperCase()
  if ((PERIODICIDADES_PIX as readonly string[]).includes(upper)) {
    return upper as PeriodicidadePix
  }
  return 'MENSAL'
}

/** Próxima dataInicial da recorrência EFI (após o pagamento imediato da Jornada 3). */
export function calcularDataInicialRecorrencia(
  periodicidade?: string | null,
  fromDate: Date = new Date()
): string {
  const periodo = normalizarPeriodicidade(periodicidade)
  const date = new Date(fromDate)

  switch (periodo) {
    case 'SEMANAL':
      date.setDate(date.getDate() + 7)
      break
    case 'TRIMESTRAL':
      date.setMonth(date.getMonth() + 3)
      break
    case 'SEMESTRAL':
      date.setMonth(date.getMonth() + 6)
      break
    case 'ANUAL':
      date.setFullYear(date.getFullYear() + 1)
      break
    case 'MENSAL':
    default:
      date.setMonth(date.getMonth() + 1)
      break
  }

  return date.toISOString().split('T')[0]
}

/** Valor cobrado no ciclo do plano (preco_anual só quando periodicidade = ANUAL). */
export function obterValorCobrancaPlano(plano: {
  preco_mensal: number
  preco_anual?: number | null
  periodicidade?: string | null
}): number {
  const periodo = normalizarPeriodicidade(plano.periodicidade)
  if (periodo === 'ANUAL' && plano.preco_anual != null && Number(plano.preco_anual) > 0) {
    return Number(plano.preco_anual)
  }
  return Number(plano.preco_mensal)
}

export function cicloPagamentoFromPeriodicidade(
  periodicidade?: string | null
): string {
  return normalizarPeriodicidade(periodicidade).toLowerCase()
}
